import React from "react";

export default function Hamburger({ open, onToggle }) {
    return (
        <button
            className={`hb ${open ? "is-open" : ""}`}
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={onToggle}
            type="button"
        >
      <span className="hb-box">
        <span className="hb-line l1" />
        <span className="hb-line l2" />
        <span className="hb-line l3" />
      </span>
        </button>
    );
}
